<!--
 * @Author: chencong
 * @Date: 2020-09-8 11:15:30
 * @LastEditTime: 2021-01-29 17:41:41
 * @LastEditors: ShiWeiShan
 * @Description: 用水计划调整申请
 * @FilePath: \fs-js-pcweb-user\src\components\applyForm\planAdjustForm.vue
-->
<template>
  <div class="plan-adjust container">
    <div class="add-form">
      <div class="add-body">
        <div class="add-table">
          <h2 class="table-title">附件2：佛山市非居民用水计划调整申请表</h2>
          <table class="common-form-table form-table-1">
            <tr class="table-row">
              <td class="column_1 td-label" colspan="1">受理号（此栏由受理单位填写）：</td>
              <td class="column_2" colspan="1">
                <el-input
                  v-model="formData['code']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['code']"
                  :title="formData['code']"
                  @input="formDataChange('code')"
                ></el-input>
              </td>
            </tr>
          </table>
          <table class="common-form-table form-table-2">
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="5">以下栏目由非居民用水户填写</td>
            </tr>

            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1"><span class="label-request">{{`* `}}</span>单位名称</td>
              <td class="column_2" colspan="4">
                <el-input
                  v-model="formData['user_name']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['user_name']"
                  :title="formData['user_name']"
                  @input="formDataChange('user_name')"
                ></el-input>
              </td>
            </tr>

            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1"><span class="label-request">{{`* `}}</span>联系人</td>
              <td class="column_2" colspan="1">
                <el-input
                  v-model="formData['contact_man']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['contact_man']"
                  :title="formData['contact_man']"
                  @input="formDataChange('contact_man')"
                ></el-input>
              </td>
              <td class="column_3 text-center td-label" colspan="1"><span class="label-request">{{`* `}}</span>联系电话</td>
              <td class="column_4" colspan="2">
                <el-input
                  v-model="formData['contact_phone']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['contact_phone']"
                  :title="formData['contact_phone']"
                  @input="formDataChange('contact_phone')"
                ></el-input>
              </td>
            </tr>

            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1"><span class="label-request">{{`* `}}</span>单位地址</td>
              <td class="column_2" colspan="2">
                <el-input
                  v-model="formData['addr_detail']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['addr_detail']"
                  :title="formData['addr_detail']"
                  @input="formDataChange('addr_detail')"
                  placeholder="xx 镇（街） xx 号"
                ></el-input>
              </td>
              <td class="column_4 text-center td-label" colspan="1">邮政编号</td>
              <td class="column_5" colspan="1">
                <el-input
                  v-model="formData['postal_code']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['postal_code']"
                  :title="formData['postal_code']"
                  @input="formDataChange('postal_code')"
                ></el-input>
              </td>
            </tr>

            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1"><span class="label-request">{{`* `}}</span>用水户号</td>
              <td class="column_2" colspan="4">
                <el-input
                  v-model="formData['meter_code_list']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['meter_code_list']"
                  :title="formData['meter_code_list']"
                  @input="formDataChange('meter_code_list')"
                ></el-input>
              </td>
            </tr>

            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1"><span class="label-request">{{`* `}}</span>用水性质</td>
              <td class="column_2" colspan="4">
                <select-water-nature
                  v-model="formData['usewater_id']"
                  :disabled="!editStatus || valueDisabled['usewater_id']"
                  @change="formDataChange('usewater_id')">
                </select-water-nature>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">执行行业用水定额</td>
              <td class="column_2" colspan="1">
                <el-input
                  v-model="formData['water_ration']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['water_ration']"
                  :title="formData['water_ration']"
                  @input="formDataChange('water_ration')"
                ></el-input>
              </td>
              <td class="column_3 text-center td-label" colspan="2">实际单位产品用水量</td>
              <td class="column_5" colspan="3">
                <el-input
                  v-model="formData['water_product']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['water_product']"
                  :title="formData['water_product']"
                  @input="formDataChange('water_product')"
                ></el-input>
              </td>
            </tr>

          </table>

          <table class="common-form-table form-table-3">
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="4">用水计划调整相关</td>
            </tr>

            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">建议调整月份</td>
              <td class="column_2 text-center td-label" colspan="1">原下达的用水计划</td>
              <td class="column_3 text-center td-label" colspan="2">调整后的数额</td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">
                <el-checkbox 
                  v-model="formData['month_check_1']"
                  :disabled="!editStatus || valueDisabled['month_check_1']">{{ plan_year }}年1月</el-checkbox>
              </td>
              <td class="column_2 text-center" colspan="1">{{ formData.plan_month_1 }}</td>
              <td class="column_3 text-center" colspan="2">
                <el-input
                  v-model="formData['after_value_1']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['after_value_1'] || !formData['month_check_1']"
                  :title="formData['after_value_1']"
                  @input="formDataChange('after_value_1')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">
                <el-checkbox 
                  v-model="formData['month_check_2']"
                  :disabled="!editStatus || valueDisabled['month_check_2']">{{ plan_year }}年2月</el-checkbox>
              </td>
              <td class="column_2 text-center" colspan="1">{{ formData.plan_month_2 }}</td>
              <td class="column_3 text-center" colspan="2">
                <el-input
                  v-model="formData['after_value_2']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['after_value_2'] || !formData['month_check_2']"
                  :title="formData['after_value_2']"
                  @input="formDataChange('after_value_2')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">
                <el-checkbox 
                  v-model="formData['month_check_3']"
                  :disabled="!editStatus || valueDisabled['month_check_3']">{{ plan_year }}年3月</el-checkbox>
              </td>
              <td class="column_2 text-center" colspan="1">{{ formData.plan_month_3 }}</td>
              <td class="column_3 text-center" colspan="2">
                <el-input
                  v-model="formData['after_value_3']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['after_value_3'] || !formData['month_check_3']"
                  :title="formData['after_value_3']"
                  @input="formDataChange('after_value_3')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">
                <el-checkbox 
                  v-model="formData['month_check_4']"
                  :disabled="!editStatus || valueDisabled['month_check_4']">{{ plan_year }}年4月</el-checkbox>
              </td>
              <td class="column_2 text-center" colspan="1">{{ formData.plan_month_4 }}</td>
              <td class="column_3 text-center" colspan="2">
                <el-input
                  v-model="formData['after_value_4']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['after_value_4'] || !formData['month_check_4']"
                  :title="formData['after_value_4']"
                  @input="formDataChange('after_value_4')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">
                <el-checkbox 
                  v-model="formData['month_check_5']"
                  :disabled="!editStatus || valueDisabled['month_check_5']">{{ plan_year }}年5月</el-checkbox>
              </td>
              <td class="column_2 text-center" colspan="1">{{ formData.plan_month_5 }}</td>
              <td class="column_3 text-center" colspan="2">
                <el-input
                  v-model="formData['after_value_5']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['after_value_5'] || !formData['month_check_5']"
                  :title="formData['after_value_5']"
                  @input="formDataChange('after_value_5')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">
                <el-checkbox 
                  v-model="formData['month_check_6']"
                  :disabled="!editStatus || valueDisabled['month_check_6']">{{ plan_year }}年6月</el-checkbox>
              </td>
              <td class="column_2 text-center" colspan="1">{{ formData.plan_month_6 }}</td>
              <td class="column_3 text-center" colspan="2">
                <el-input
                  v-model="formData['after_value_6']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['after_value_6'] || !formData['month_check_6']"
                  :title="formData['after_value_6']"
                  @input="formDataChange('after_value_6')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">
                <el-checkbox 
                  v-model="formData['month_check_7']"
                  :disabled="!editStatus || valueDisabled['month_check_7']">{{ plan_year }}年7月</el-checkbox>
              </td>
              <td class="column_2 text-center" colspan="1">{{ formData.plan_month_7 }}</td>
              <td class="column_3 text-center" colspan="2">
                <el-input
                  v-model="formData['after_value_7']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['after_value_7'] || !formData['month_check_7']"
                  :title="formData['after_value_7']"
                  @input="formDataChange('after_value_7')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">
                <el-checkbox 
                  v-model="formData['month_check_8']"
                  :disabled="!editStatus || valueDisabled['month_check_8']">{{ plan_year }}年8月</el-checkbox>
              </td>
              <td class="column_2 text-center" colspan="1">{{ formData.plan_month_8 }}</td>
              <td class="column_3 text-center" colspan="2">
                <el-input
                  v-model="formData['after_value_8']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['after_value_8'] || !formData['month_check_8']"
                  :title="formData['after_value_8']"
                  @input="formDataChange('after_value_8')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">
                <el-checkbox 
                  v-model="formData['month_check_9']"
                  :disabled="!editStatus || valueDisabled['month_check_9']">{{ plan_year }}年9月</el-checkbox>
              </td>
              <td class="column_2 text-center" colspan="1">{{ formData.plan_month_9 }}</td>
              <td class="column_3 text-center" colspan="2">
                <el-input
                  v-model="formData['after_value_9']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['after_value_9'] || !formData['month_check_9']"
                  :title="formData['after_value_9']"
                  @input="formDataChange('after_value_9')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">
                <el-checkbox 
                  v-model="formData['month_check_10']"
                  :disabled="!editStatus || valueDisabled['month_check_10']">{{ plan_year }}年10月</el-checkbox>
              </td>
              <td class="column_2 text-center" colspan="1">{{ formData.plan_month_10 }}</td>
              <td class="column_3 text-center" colspan="2">
                <el-input
                  v-model="formData['after_value_10']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['after_value_10'] || !formData['month_check_10']"
                  :title="formData['after_value_10']"
                  @input="formDataChange('after_value_10')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">
                <el-checkbox 
                  v-model="formData['month_check_11']"
                  :disabled="!editStatus || valueDisabled['month_check_11']">{{ plan_year }}年11月</el-checkbox>
              </td>
              <td class="column_2 text-center" colspan="1">{{ formData.plan_month_11 }}</td>
              <td class="column_3 text-center" colspan="2">
                <el-input
                  v-model="formData['after_value_11']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['after_value_11'] || !formData['month_check_11']"
                  :title="formData['after_value_11']"
                  @input="formDataChange('after_value_11')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">
                <el-checkbox 
                  v-model="formData['month_check_12']"
                  :disabled="!editStatus || valueDisabled['month_check_12']">{{ plan_year }}年12月</el-checkbox>
              </td>
              <td class="column_2 text-center" colspan="1">{{ formData.plan_month_12 }}</td>
              <td class="column_3 text-center" colspan="2">
                <el-input
                  v-model="formData['after_value_12']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['after_value_12'] || !formData['month_check_12']"
                  :title="formData['after_value_12']"
                  @input="formDataChange('after_value_12')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1"><span class="label-request">{{`* `}}</span>调整理由</td>
              <td class="column_2 text-center" colspan="3">
                <el-select
                  v-model="formData['adjust_reason']"
                  placeholder="请选择"
                  clearable
                  @change="formDataChange('adjust_reason')"
                  :disabled="!editStatus || valueDisabled['adjust_reason']"
                  :title="F_getOptionLabel(dictLabelValues['UsewaterPlanAdjustReason']|| [], formData['adjust_reason'])"
                  size="mini"
                >
                  <el-option
                    v-for="value in (dictLabelValues['UsewaterPlanAdjustReason'] || [])"
                    :key="value.value"
                    :label="value.label"
                    :value="value.value"
                  ></el-option>
                </el-select>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">主要生产产品名称</td>
              <td class="column_2 text-center" colspan="1">
                <el-input
                  v-model="formData['production_name_1']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['production_name_1']"
                  :title="formData['production_name_1']"
                  @input="formDataChange('production_name_1')"
                ></el-input>
              </td>
              <td class="column_3 text-center" colspan="1">
                <el-input
                  v-model="formData['production_name_2']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['production_name_2']"
                  :title="formData['production_name_2']"
                  @input="formDataChange('production_name_2')"
                ></el-input>
              </td>
              <td class="column_4 text-center" colspan="1">
                <el-input
                  v-model="formData['production_name_3']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['production_name_3']"
                  :title="formData['production_name_3']"
                  @input="formDataChange('production_name_3')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">计划产量</td>
              <td class="column_2 text-center" colspan="1">
                <el-input
                  v-model="formData['yield_1']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['yield_1']"
                  :title="formData['yield_1']"
                  @input="formDataChange('yield_1')"
                ></el-input>
              </td>
              <td class="column_3 text-center" colspan="1">
                <el-input
                  v-model="formData['yield_2']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['yield_2']"
                  :title="formData['yield_2']"
                  @input="formDataChange('yield_2')"
                ></el-input>
              </td>
              <td class="column_4 text-center" colspan="1">
                <el-input
                  v-model="formData['yield_3']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['yield_3']"
                  :title="formData['yield_3']"
                  @input="formDataChange('yield_3')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">采用的用水定额</td>
              <td class="column_2 text-center" colspan="1">
                <el-input
                  v-model="formData['usewater_1']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['usewater_1']"
                  :title="formData['usewater_1']"
                  @input="formDataChange('usewater_1')"
                ></el-input>
              </td>
              <td class="column_3 text-center" colspan="1">
                <el-input
                  v-model="formData['usewater_2']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['usewater_2']"
                  :title="formData['usewater_2']"
                  @input="formDataChange('usewater_2')"
                ></el-input>
              </td>
              <td class="column_4 text-center" colspan="1">
                <el-input
                  v-model="formData['usewater_3']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['usewater_3']"
                  :title="formData['usewater_3']"
                  @input="formDataChange('usewater_3')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1"><span class="label-request">{{`* `}}</span>用水计划调整合理性说明（可另附页说明）</td>
              <td class="column_2 text-center" colspan="3">
                <el-input
                  v-model="formData['adjust_statement']"
                  size="mini"
                  type="textarea"
                  clearable
                  :disabled="!editStatus || valueDisabled['adjust_statement']"
                  :title="formData['adjust_statement']"
                  @input="formDataChange('adjust_statement')"
                ></el-input>
              </td>
            </tr>


            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">附件清单<br/>（增大用水计划量时，请提供以下附件）</td>
              <td class="column_2" colspan="3">
                1.《水量平衡测试报告》复印件（前一年内月平均用水量5000立方米以及以上的单位应当提交）：<common-upload
                  v-model="formData['file_1']"
                  :disabled="!editStatus || valueDisabled['file_1']"
                  fileAccept="image/jpeg,application/pdf"
                  @change="formDataChange('file_1')">
                </common-upload>
                2.扩大生产规模的，提供本企业水重复利用率、用水单耗、上一年度生产经营规模、申报期生产经营规模扩大情况等用水量增加合理性说明资料：<common-upload
                  v-model="formData['file_2']"
                  :disabled="!editStatus || valueDisabled['file_2']"
                  fileAccept="image/jpeg,application/pdf"
                  @change="formDataChange('file_2')">
                </common-upload>
                3.扩大经营规模的，提供本企业主要用水项目用水量增加合理性说明资料：<common-upload
                  v-model="formData['file_3']"
                  :disabled="!editStatus || valueDisabled['file_3']"
                  fileAccept="image/jpeg,application/pdf"
                  @change="formDataChange('file_3')">
                </common-upload>
                4.建设项目批文、总工程量和分月度施工计划等建设项目用水量增加合理性说明资料：<common-upload
                  v-model="formData['file_4']"
                  :disabled="!editStatus || valueDisabled['file_4']"
                  fileAccept="image/jpeg,application/pdf"
                  @change="formDataChange('file_4')">
                </common-upload>
                5.用水设施建设或设备购买等用水量增加合理性说明资料：<common-upload
                  v-model="formData['file_5']"
                  :disabled="!editStatus || valueDisabled['file_5']"
                  fileAccept="image/jpeg,application/pdf"
                  @change="formDataChange('file_5')">
                </common-upload>
                6.人员数量证明材料：<common-upload
                  v-model="formData['file_6']"
                  :disabled="!editStatus || valueDisabled['file_6']"
                  fileAccept="image/jpeg,application/pdf"
                  @change="formDataChange('file_6')">
                </common-upload>
                7.绿化面积增加的证明材料：<common-upload
                  v-model="formData['file_7']"
                  :disabled="!editStatus || valueDisabled['file_7']"
                  fileAccept="image/jpeg,application/pdf"
                  @change="formDataChange('file_7')">
                </common-upload>
                8.其他用水相关证明材料：<common-upload
                  v-model="formData['file_8']"
                  :disabled="!editStatus || valueDisabled['file_8']"
                  fileAccept="image/jpeg,application/pdf"
                  @change="formDataChange('file_8')">
                </common-upload>
              </td>
            </tr>
          </table>

          <table class="common-form-table form-table-4">
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="8">节水相关信息（根据实际情况填写）</td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" rowspan="10" colspan="1">建议条件说明</td>
              <td class="column_2 text-center td-label" colspan="2">本单位已设立专门用水管理机构</td>
              <td class="column_4 text-center" colspan="1">
                <el-switch
                  v-model="formData['has_charge_group']"
                  :disabled="!editStatus || valueDisabled['has_charge_group']"
                  active-text="是"
                  inactive-text="否"
                  size="mini"
                ></el-switch>
              </td>
              <td class="column_5 text-center td-label" colspan="1">用水管理机构名称</td>
              <td class="column_6 text-center" colspan="1">
                <el-input
                  v-model="formData['charge_group_name']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['charge_group_name']"
                  :title="formData['charge_group_name']"
                  @input="formDataChange('charge_group_name')"
                ></el-input>
              </td>
              <td class="column_7 text-center td-label" colspan="1">电话号码</td>
              <td class="column_8 text-center" colspan="1">
                <el-input
                  v-model="formData['charge_group_phone']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['charge_group_phone']"
                  :title="formData['charge_group_phone']"
                  @input="formDataChange('charge_group_phone')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_2 text-center td-label" colspan="2">本单位已指定专人负责计划用水工作</td>
              <td class="column_4 text-center" colspan="1">
                <el-switch
                  v-model="formData['has_charge_man']"
                  :disabled="!editStatus || valueDisabled['has_charge_man']"
                  active-text="是"
                  inactive-text="否"
                  size="mini"
                ></el-switch>
              </td>
              <td class="column_5 text-center td-label" colspan="1">专管人姓名</td>
              <td class="column_6 text-center" colspan="1">
                <el-input
                  v-model="formData['charge_man_name']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['charge_man_name']"
                  :title="formData['charge_man_name']"
                  @input="formDataChange('charge_man_name')"
                ></el-input>
              </td>
              <td class="column_7 text-center td-label" colspan="1">电话号码</td>
              <td class="column_8 text-center" colspan="1">
                <el-input
                  v-model="formData['charge_man_phone']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['charge_man_phone']"
                  :title="formData['charge_man_phone']"
                  @input="formDataChange('charge_man_phone')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_2 text-center td-label" rowspan="7" colspan="1">本单位已采取的节水措施</td>
              <td class="column_3 text-center td-label" colspan="1">加强供水管道和闸、阀、泵、储水池等用水设施的管养维护</td>
              <td class="column_4 text-center" colspan="1">
                <el-switch
                  v-model="formData['has_maintain']"
                  :disabled="!editStatus || valueDisabled['has_maintain']"
                  active-text="是"
                  inactive-text="否"
                  size="mini"
                ></el-switch>
              </td>
              <td class="column_5 text-center td-label" colspan="1">定期抄录水表</td>
              <td class="column_6 text-center" colspan="1">
                <el-switch
                  v-model="formData['has_regular_record']"
                  :disabled="!editStatus || valueDisabled['has_regular_record']"
                  active-text="是"
                  inactive-text="否"
                  size="mini"
                ></el-switch>
              </td>
              <td class="column_7 text-center td-label" colspan="1">抄录周期</td>
              <td class="column_8 text-center" colspan="1">
                <el-select
                  v-model="formData['record_period']"
                  placeholder="请选择"
                  clearable
                  @change="formDataChange('record_period')"
                  :disabled="!editStatus || valueDisabled['record_period']"
                  :title="F_getOptionLabel(dictLabelValues['UsewaterPlanSvaingRP']|| [], formData['record_period'])"
                  size="mini"
                >
                  <el-option
                    v-for="value in (dictLabelValues['UsewaterPlanSvaingRP'] || [])"
                    :key="value.value"
                    :label="value.label"
                    :value="value.value"
                  ></el-option>
                </el-select>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_3 text-center td-label" rowspan="4" colspan="1">采用节水型器具</td>
              <td class="column_4 text-center" rowspan="4" colspan="1">
                <el-switch
                  v-model="formData['has_saving_tool']"
                  :disabled="!editStatus || valueDisabled['has_saving_tool']"
                  active-text="是"
                  inactive-text="否"
                  size="mini"
                ></el-switch>
              </td>
              <td class="column_5 text-center td-label" rowspan="4" colspan="1">节水型用水器具使用比例（%）</td>
              <td class="column_6 text-center td-label" colspan="2">水龙头</td>
              <td class="column_8 text-center" colspan="1">
                <el-input
                  v-model="formData['tool_water_faucet']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['tool_water_faucet']"
                  :title="formData['tool_water_faucet']"
                  @input="formDataChange('tool_water_faucet')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_6 text-center td-label" colspan="2">冲厕</td>
              <td class="column_8 text-center" colspan="1">
                <el-input
                  v-model="formData['tool_flush_toilet']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['tool_flush_toilet']"
                  :title="formData['tool_flush_toilet']"
                  @input="formDataChange('tool_flush_toilet')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_6 text-center td-label" rowspan="2" colspan="1">其他</td>
              <td class="column_7 text-center" colspan="1">
                <el-input
                  v-model="formData['tool_other_name_1']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['tool_other_name_1']"
                  :title="formData['tool_other_name_1']"
                  @input="formDataChange('tool_other_name_1')"
                ></el-input>
              </td>
              <td class="column_8 text-center" colspan="1">
                <el-input
                  v-model="formData['tool_other_value_1']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['tool_other_value_1']"
                  :title="formData['tool_other_value_1']"
                  @input="formDataChange('tool_other_value_1')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_7 text-center" colspan="1">
                <el-input
                  v-model="formData['tool_other_name_2']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['tool_other_name_2']"
                  :title="formData['tool_other_name_2']"
                  @input="formDataChange('tool_other_name_2')"
                ></el-input>
              </td>
              <td class="column_8 text-center" colspan="1">
                <el-input
                  v-model="formData['tool_other_value_2']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['tool_other_value_2']"
                  :title="formData['tool_other_value_2']"
                  @input="formDataChange('tool_other_value_2')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_3 text-center td-label" colspan="1">采用节水工艺</td>
              <td class="column_4 text-center" colspan="1">
                <el-switch
                  v-model="formData['has_saving_craft']"
                  :disabled="!editStatus || valueDisabled['has_saving_craft']"
                  active-text="是"
                  inactive-text="否"
                  size="mini"
                ></el-switch>
              </td>
              <td class="column_5 text-center td-label" colspan="1">工艺名称</td>
              <td class="column_6 text-center" colspan="3">
                <el-input
                  v-model="formData['saving_craft_name']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['saving_craft_name']"
                  :title="formData['saving_craft_name']"
                  @input="formDataChange('saving_craft_name')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_3 text-center td-label" colspan="1">采用节水设备</td>
              <td class="column_4 text-center" colspan="1">
                <el-switch
                  v-model="formData['has_saving_equipment']"
                  :disabled="!editStatus || valueDisabled['has_saving_equipment']"
                  active-text="是"
                  inactive-text="否"
                  size="mini"
                ></el-switch>
              </td>
              <td class="column_5 text-center td-label" colspan="1">设备名称</td>
              <td class="column_6 text-center" colspan="3">
                <el-input
                  v-model="formData['saving_equipment_name']"
                  size="mini"
                  clearable
                  :disabled="!editStatus || valueDisabled['saving_equipment_name']"
                  :title="formData['saving_equipment_name']"
                  @input="formDataChange('saving_equipment_name')"
                ></el-input>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_2 text-center td-label" colspan="2">已开展水平衡测试</td>
              <td class="column_4 text-center" colspan="1">
                <el-switch
                  v-model="formData['has_waterbalance']"
                  :disabled="!editStatus || valueDisabled['has_waterbalance']"
                  active-text="是"
                  inactive-text="否"
                  size="mini"
                ></el-switch>
              </td>
              <td class="column_5 text-center td-label" colspan="1">测试时间</td>
              <td class="column_6 text-center" colspan="1">
                <el-date-picker
                  v-model="formData['waterbalance_time']"
                  size="mini"
                  type="date"
                  placeholder="选择日期"
                  :disabled="!editStatus || valueDisabled['waterbalance_time']"
                  value-format="yyyy-MM-dd"
                  @input="formDataChange('waterbalance_time')"
                ></el-date-picker>
              </td>
              <td class="column_7 text-center td-label" colspan="1">有效期</td>
              <td class="column_8 text-center" colspan="1">
                <el-date-picker
                  v-model="formData['waterbalance_deadline']"
                  size="mini"
                  type="date"
                  placeholder="选择日期"
                  :disabled="!editStatus || valueDisabled['waterbalance_deadline']"
                  value-format="yyyy-MM-dd"
                  @input="formDataChange('waterbalance_deadline')"
                ></el-date-picker>
              </td>
            </tr>
          </table>

          <table class="common-form-table form-table-5">
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">特别声明</td>
            </tr>
            <tr class="table-row">
              <td
                class="column_1 text-center"
                colspan="1"
              >本建议表所填内容正确无误，附件所提交的资料及证明文件真实有效，如有虚假将承担相应法律责任。</td>
            </tr>
          </table>

          <table class="common-form-table form-table-6">
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="2">以下栏目由核定部门填写</td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">资料真实齐全</td>
              <td class="column_2 text-center" colspan="1">
                <el-switch
                  v-model="formData['is_complete']"
                  disabled
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="0"
                  size="mini"
                ></el-switch>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">用水计划合理</td>
              <td class="column_2 text-center" colspan="1">
                <el-switch
                  v-model="formData['is_reasonable']"
                  disabled
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="0"
                  size="mini"
                ></el-switch>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">同意用水计划调整建议</td>
              <td class="column_2 text-center" colspan="1">
                <el-switch
                  v-model="formData['is_agreeapply']"
                  disabled
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="0"
                  size="mini"
                ></el-switch>
              </td>
            </tr>
            <tr class="table-row">
              <td class="column_1 text-center td-label" colspan="1">核定结果</td>
              <td class="column_2 text-center" colspan="1">
                <el-input
                  v-model="formData['audit_opinion']"
                  size="mini"
                  type="textarea"
                  clearable
                  disabled
                  :title="formData['audit_opinion']"
                  @input="formDataChange('audit_opinion')"
                ></el-input>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="bottom-tools clearfix">
        <div class="tools-box">
          <div class="tools-item">
            <el-button @click="cancleCancle" size="mini">取消</el-button>
          </div>
          <div class="tools-item">
            <el-button @click="confirmClick" type="success" size="mini">提交</el-button>
          </div>
        </div>
      </div>
    </div>
    <hd-loading v-if="pageLoading"></hd-loading>
  </div>
</template>

<script>
import {
  A_PUL_SingleQuery,
  A_WPAL_EditV2,
  A_UWPL_PageQuery
} from '@/assets/js/axiosPresets.js'
import {
  F_getOptionLabel,
  F_validateForm
} from '@/assets/js/publicFunSet.js'
import selectWaterNature from '@/components/util/selectWaterNature'
import commonUpload from '@/components/public/commonUpload'
export default {
  components: {
    selectWaterNature,
    commonUpload
  },
  props: {
    plan_year: Number
  },
  data () {
    return {
      dictKeyList: [
        'UsewaterPlanSvaingRP',
        'UsewaterPlanAdjustReason'
      ],
      pageLoading: false,
      formData: {},
      editStatus: true,
      valueDisabled: {
        code: true,
        user_name: true
        // contact_man: true,
        // contact_phone: true,
        // addr_detail: true,
        // postal_code: true,
        // meter_code_list: true,
        // usewater_id: true
      }
    }
  },
  computed: {
    rules () {
      return {
        user_name: { required: true, message: { required: '请输入单位名称' } },
        contact_man: { required: true, message: { required: '请输入联系人' } },
        contact_phone: { required: true, message: { required: '请输入联系电话' } },
        addr_detail: { required: true, message: { required: '请输入单位地址' } },
        meter_code_list: { required: true, message: { required: '请输入用水户号' } },
        usewater_id: { required: true, message: { required: '请输入用水性质' } },
        adjust_reason: { required: true, message: { required: '请选择调整理由' } },
        adjust_statement: { required: true, message: { required: '请输入水量调整说明' } }
      }
    },
    currentUser () {
      return this.$store.state.userInfo
    },
    dictLabelValues () {
      return this.$store.state.dictLabelValues
    }
  },
  methods: {
    F_getOptionLabel,
    async initData () {
      this.pageLoading = true
      await this.getWaterPlanList()
      await this.$store.dispatch('getDictLabelValues', this.dictKeyList)
      this.pageLoading = false
    },
    async getWaterPlanList () {
      const data = {
        user_id: this.currentUser.oid,
        // audit_status: "5",
        pageIndex: 1,
        pageSize: 1000,
        plan_year: this.plan_year,
        sortField: "plan_year",
        sortOrder: 'desc'
      }
      const res = await this.$F_checkAxiosIn(A_UWPL_PageQuery(data))
      if (!res || res.data.Content.Total === 0) {
        this.$message({
          showClose: true,
          message: '请先核定该年用水计划！',
          type: 'warning'
        })
        this.cancleCancle()
        return
      }
      const userDataSave = res.data.Content.list[0]
      this.formData.user_id = userDataSave.user_id
      this.formData.user_name = userDataSave.user_name
      this.formData.contact_man = userDataSave.contact_man
      this.formData.contact_phone = userDataSave.contact_phone
      this.formData.addr_detail = userDataSave.addr_detail
      this.formData.postal_code = userDataSave.postal_code
      this.formData.meter_code_list = userDataSave.meter_code_list
      this.formData.usewater_id = userDataSave.usewater_id
      this.formData.water_ration = userDataSave.water_ration
      this.formData.water_product = userDataSave.water_product
      this.formData.green_area = userDataSave.green_area
      this.formData.adjust_reason = userDataSave.adjust_reason
      this.formData.adjust_statement = userDataSave.adjust_statement
      this.formData.has_charge_group = userDataSave.has_charge_group === 1
      this.formData.charge_group_name = userDataSave.charge_group_name
      this.formData.charge_group_phone = userDataSave.charge_group_phone
      this.formData.has_charge_man = userDataSave.has_charge_man === 1
      this.formData.charge_man_name = userDataSave.charge_man_name
      this.formData.charge_man_phone = userDataSave.charge_man_phone
      this.formData.has_maintain = userDataSave.has_maintain === 1
      this.formData.has_regular_record = userDataSave.has_regular_record === 1
      this.formData.record_period = userDataSave.record_period
      this.formData.has_saving_tool = userDataSave.has_saving_tool === 1
      this.formData.tool_water_faucet = userDataSave.tool_water_faucet
      this.formData.tool_flush_toilet = userDataSave.tool_flush_toilet
      this.formData.tool_other_name_1 = userDataSave.tool_other_name_1
      this.formData.tool_other_name_2 = userDataSave.tool_other_name_2
      this.formData.tool_other_value_1 = userDataSave.tool_other_value_1
      this.formData.tool_other_value_2 = userDataSave.tool_other_value_2
      this.formData.has_saving_craft = userDataSave.has_saving_craft === 1
      this.formData.saving_craft_name = userDataSave.saving_craft_name
      this.formData.has_saving_equipment = userDataSave.has_saving_equipment === 1
      this.formData.saving_equipment_name = userDataSave.saving_equipment_name
      this.formData.has_waterbalance = userDataSave.has_waterbalance === 1
      this.formData.waterbalance_time = userDataSave.waterbalance_time
      this.formData.waterbalance_deadline = userDataSave.waterbalance_deadline
      this.formData.production_name_1 = userDataSave.production_name_1
      this.formData.production_name_2 = userDataSave.production_name_2
      this.formData.production_name_3 = userDataSave.production_name_3
      this.formData.yield_1 = userDataSave.yield_1
      this.formData.yield_2 = userDataSave.yield_2
      this.formData.yield_3 = userDataSave.yield_3
      this.formData.usewater_1 = userDataSave.usewater_1
      this.formData.usewater_2 = userDataSave.usewater_2
      this.formData.usewater_3 = userDataSave.usewater_3

      userDataSave.usewater_plan_detail.forEach(item => {
        const key = 'plan_month_' + new Date(item.plan_month).format('M')
        this.formData[key] = item.plan_val
      })
      this.formData = _.cloneDeep(this.formData)
    },
    async getUserInfo () {
      this.pageLoading = true
      const res = await this.$F_checkAxiosIn(A_PUL_SingleQuery(this.currentUser.oid))
      this.pageLoading = false
      if (!res) {
        return
      }
      const userDataSave = res.data.Content
      this.formData.user_id = userDataSave.oid
      this.formData.user_name = userDataSave.name
      this.formData.contact_man = userDataSave.contact_man
      this.formData.contact_phone = userDataSave.contact_phone
      this.formData.postal_code = userDataSave.postal_code
      this.formData.addr_detail = userDataSave.addr_detail
      this.formData.usewater_id = userDataSave.usewater_id
      this.formData = _.cloneDeep(this.formData)
    },
    formDataChange (key) {
      console.log(key)
    },
    async confirmClick () {
      // 表单校验
      const args = F_validateForm(this.formData, this.rules)
      if (!args[0]) {
        return
      }
      const child_list = []
      let _bo = false
      for (let index = 0; index < 12; index++) {
        if (this.formData['month_check_'+(index + 1)]) {
          _bo = true
          const _val = this.formData['after_value_'+(index + 1)]
          if (!_val) {
            this.$message({
              showClose: true,
              message: `请填写${index+1}月调整水量！`,
              type: 'warning'
            })
            return
          }
          child_list.push({
            adjust_val: _val,
            adjust_month: (index + 1)
          })
        }
      }
      if (!_bo) {
        this.$message({
          showClose: true,
          message: '请勾选并填写调整水量！',
          type: 'warning'
        })
        return
      }
      await this.$confirm('确认保存？')

      const newFormData = new FormData()
      // 文件
      if (this.formData.file_1 != null) {
        this.formData.file_1.forEach(item => {
          newFormData.append('file_1', item)
        })
      }
      if (this.formData.file_2 != null) {
        this.formData.file_2.forEach(item => {
          newFormData.append('file_2', item)
        })
      }
      if (this.formData.file_3 != null) {
        this.formData.file_3.forEach(item => {
          newFormData.append('file_3', item)
        })
      }
      if (this.formData.file_4 != null) {
        this.formData.file_4.forEach(item => {
          newFormData.append('file_4', item)
        })
      }
      if (this.formData.file_5 != null) {
        this.formData.file_5.forEach(item => {
          newFormData.append('file_5', item)
        })
      }
      if (this.formData.file_6 != null) {
        this.formData.file_6.forEach(item => {
          newFormData.append('file_6', item)
        })
      }
      if (this.formData.file_7 != null) {
        this.formData.file_7.forEach(item => {
          newFormData.append('file_7', item)
        })
      }
      if (this.formData.file_8 != null) {
        this.formData.file_8.forEach(item => {
          newFormData.append('file_8', item)
        })
      }
      // 表单
      newFormData.append('user_id', this.currentUser.oid)

      newFormData.append('plan_year', this.plan_year)
      newFormData.append('user_name', this.formData.user_name)
      newFormData.append('contact_man', this.formData.contact_man || '')
      newFormData.append('contact_phone', this.formData.contact_phone || '')
      newFormData.append('addr_detail', this.formData.addr_detail || '')
      newFormData.append('postal_code', this.formData.postal_code || '')
      newFormData.append('meter_code_list', this.formData.meter_code_list || '')
      newFormData.append('usewater_id', this.formData.usewater_id || '')
      newFormData.append('water_ration', this.formData.water_ration || '')
      newFormData.append('water_product', this.formData.water_product || '')
      newFormData.append('green_area', this.formData.green_area || '')
      newFormData.append('adjust_reason', this.formData.adjust_reason || '')
      newFormData.append('adjust_statement', this.formData.adjust_statement || '')
      newFormData.append('has_charge_group', this.formData.has_charge_group?1:0)
      newFormData.append('charge_group_name', this.formData.charge_group_name || '')
      newFormData.append('charge_group_phone', this.formData.charge_group_phone || '')
      newFormData.append('has_charge_man', this.formData.has_charge_man?1:0)
      newFormData.append('charge_man_name', this.formData.charge_man_name || '')
      newFormData.append('charge_man_phone', this.formData.charge_man_phone || '')
      newFormData.append('has_maintain', this.formData.has_maintain?1:0)
      newFormData.append('has_regular_record', this.formData.has_regular_record?1:0)
      newFormData.append('record_period', this.formData.record_period || '')
      newFormData.append('has_saving_tool', this.formData.has_saving_tool?1:0)
      newFormData.append('tool_water_faucet', this.formData.tool_water_faucet || '')
      newFormData.append('tool_flush_toilet', this.formData.tool_flush_toilet || '')
      newFormData.append('tool_other_name_1', this.formData.tool_other_name_1 || '')
      newFormData.append('tool_other_name_2', this.formData.tool_other_name_2 || '')
      newFormData.append('tool_other_value_1', Number(this.formData.tool_other_value_1) || '')
      newFormData.append('tool_other_value_2', Number(this.formData.tool_other_value_2) || '')
      newFormData.append('has_saving_craft', this.formData.has_saving_craft?1:0)
      newFormData.append('saving_craft_name', this.formData.saving_craft_name)
      newFormData.append('has_saving_equipment', this.formData.has_saving_equipment?1:0)
      newFormData.append('saving_equipment_name', this.formData.saving_equipment_name)
      newFormData.append('has_waterbalance', this.formData.has_waterbalance?1:0)
      newFormData.append('waterbalance_time', this.formData.waterbalance_time || '')
      newFormData.append('waterbalance_deadline', this.formData.waterbalance_deadline || '')
      newFormData.append('production_name_1', this.formData.production_name_1)
      newFormData.append('production_name_2', this.formData.production_name_2)
      newFormData.append('production_name_3', this.formData.production_name_3)
      newFormData.append('yield_1', this.formData.yield_1)
      newFormData.append('yield_2', this.formData.yield_2)
      newFormData.append('yield_3', this.formData.yield_3)
      newFormData.append('usewater_1', this.formData.usewater_1)
      newFormData.append('usewater_2', this.formData.usewater_2)
      newFormData.append('usewater_3', this.formData.usewater_3)
      newFormData.append('child_list', JSON.stringify(child_list))

      this.pageLoading = true
      const res = await this.$F_checkAxiosIn(A_WPAL_EditV2(newFormData))
      this.pageLoading = false
      if (!res) {
        return
      }
      this.$message({
        showClose: true,
        message: '操作成功！',
        type: 'success'
      })
      this.$emit('successThen')
    },
    cancleCancle () {
      this.$emit('cancle')
    }
  },
  mounted () {
    this.initData()
  }
}
</script>

<style lang="scss">
.plan-adjust {
  background-color: #efefef;
  @include flex-column;
  .user-select {
    padding: 0 6px;
    border-bottom: 2px solid $bd-color-second;
    background-color: #fff;
  }
  .add-form{
    height: 0;
    flex: 1;
    position: relative;
    @include flex-column;
    .add-body{
      height: 0;
      flex: 1;
      overflow-y: auto;
      .add-table{
        border: $bd-common;
        padding: 20px;
        background-color: #fff;
        margin: 12px auto;
        width: 1000px;
        td{
          padding: 2px 4px;
          line-height: 24px;
          box-sizing: border-box;
          vertical-align: middle;
          border: 1px solid #333;
          .el-cascader,
          .el-input {
            display: block;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .el-select,
          .el-date-editor.el-input{
            width: 100%;
          }
          .el-switch {
            padding: 4px 0;
          }
        }
        .cell{
          line-height: 24px;
        }
        .form-table{
          width: 100%;
          margin-bottom: 10px;
          .table-inner{
            width: 100%;
          }
          .table-row{
          }
          .row-border-none {
            border: 0;
          }
        }
        .text-center{
          text-align: center;
        }
        .form-table-1{
          .column_1{
            width: 280px;
          }
        }
        .form-table-2{
          .column_1{
            width: 160px;
          }
          .column_2{
            width: 160px;
          }
          .column_3{
            width: 160px;
          }
          .column_4{
            width: 160px;
          }
          .column_5{
            width: 160px;
          }
        }
        .form-table-3{
          .column_1{
            width: 180px;
          }
        }
        .form-table-4{
          .column_1{
            width: 60px;
          }
          .column_2{
            width: 60px;
          }
          .column_4{
            width: 100px;
          }
          .column_6{
            width: 134px;
          }
          .column_7{
            width: 100px;
          }
          .column_8{
            width: 134px;
          }
        }
        .form-table-6 {
          .column_1 {
            width: 180px;
          }
        }
      }
    }
    .bottom-tools{
      background-color: #fff;
      border-top: $bd-common;
      .tools-box {
        float: right;
        padding: 5px;
        .tools-item {
          display: inline-block;
          margin-left: 6px;
        }
      }
    }
  }

}
</style>